import script from "./SuggestionTags.vue?vue&type=script&lang=js"
export * from "./SuggestionTags.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__